
async function addProductToCart(variantId, button) {
  let originalText = button.innerHTML;
  try {
    // Show loading indicator and disable button                    
    button.innerHTML = '<span class="loading-dots">Adding</span>';
    button.disabled = true;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!response.ok) {
      throw new Error(`Failed to add product to cart: ${response.statusText}`);
    }

    await response.json();
    await updateCartDrawer();

  } catch (error) {
    console.error('Error adding product to cart:', error);
  } finally {
    // Restore button text and re-enable button
    button.innerHTML = originalText;
    button.disabled = false;
  }
}

async function updateCartDrawer() {
  try {
    const response = await fetch('/?section_id=cart-drawer');

    if (!response.ok) {
      throw new Error(`Failed to fetch cart drawer: ${response.statusText}`);
    }

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newCartDrawer = doc.querySelector('#CartDrawer');
    const existingCartDrawer = document.querySelector('#CartDrawer');

    if (existingCartDrawer && newCartDrawer) {
      existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
    }
                  
    setRecommendedProduct(); // Reattach event listener if needed
  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}

function setRecommendedProduct() {
  const addToCartButton = document.getElementById('add-recommended-to-cart');
  const productSizeSelect = document.getElementById('recommended-product-size');

  if (!addToCartButton || !productSizeSelect) {
    console.error('Required elements not found: add-recommended-to-cart or recommended-product-size');
    return;
  }

  addToCartButton.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent default behavior
    const variantId = productSizeSelect.value;
    addProductToCart(variantId, addToCartButton);
  });
}  
if ( document.getElementById('cart-recommendation-product') ){
  setRecommendedProduct();
}